// extracted by mini-css-extract-plugin
module.exports = {"header":"BeigeHeaderContent_header__M0y9J","title":"BeigeHeaderContent_title__bO81R","mainText":"BeigeHeaderContent_mainText__KGIQf"};